import { useState, useEffect } from 'react';
import { realtimeDb } from '../firebase';
import { ref, onValue } from 'firebase/database';

interface UseServerTimeReturn {
  serverTimeOffset: number;
  getServerTime: () => number;
}

/**
 * Hook joka synkronoi asiakkaan ajan Firebase-palvelimen aikaan.
 * 
 * Firebase Realtime Database tarjoaa .info/serverTimeOffset-arvon,
 * joka kertoo millisekunteina eron asiakkaan ja palvelimen välillä.
 * 
 * Tämä varmistaa, että kaikki käyttäjät näkevät ajan synkronoituna
 * palvelimen aikaan, eikä varaaminen ala aikaisemmin niillä joiden
 * laitteiden kello on edellä.
 */
export const useServerTime = (): UseServerTimeReturn => {
  const [serverTimeOffset, setServerTimeOffset] = useState<number>(0);

  useEffect(() => {
    // Kuuntele Firebase Realtime Databasen .info/serverTimeOffset-arvoa
    const offsetRef = ref(realtimeDb, '.info/serverTimeOffset');
    
    const unsubscribe = onValue(offsetRef, (snapshot) => {
      const offset = snapshot.val() || 0;
      setServerTimeOffset(offset);
    });

    return () => unsubscribe();
  }, []);

  /**
   * Palauttaa nykyisen ajan synkronoituna palvelimen aikaan
   */
  const getServerTime = (): number => {
    return Date.now() + serverTimeOffset;
  };

  return {
    serverTimeOffset,
    getServerTime,
  };
};
